export default __webpack_public_path__ + "static/media/img-1.a93afc41.png";